<template>
  <div>
    <AGB />
  </div>
</template>

<script>
import AGB from '../components/AGB';

export default {
  name: 'AGBView',
  components: {
    AGB
  },
};
</script>

<style scoped>
  div {
    margin: 50px;
  }
</style>
